import { createSlice } from '@reduxjs/toolkit';

// The JWT token is stored in sessionStorage (survives page refreshes, cleared
// on tab/browser close). User and project display info go to localStorage.
// The proper server-side solution is an HttpOnly cookie set by the backend.

const TOKEN_KEY   = 'futurizer_token';
const USER_KEY    = 'futurizer_user';
const PROJECT_KEY = 'futurizer_project';

function loadInitialState() {
  try {
    return {
      token:   sessionStorage.getItem(TOKEN_KEY)              || null,
      user:    JSON.parse(localStorage.getItem(USER_KEY))     || null,
      project: JSON.parse(localStorage.getItem(PROJECT_KEY))  || null,
    };
  } catch {
    return { token: null, user: null, project: null };
  }
}

const authSlice = createSlice({
  name: 'auth',
  initialState: loadInitialState(),
  reducers: {
    setCredentials(state, { payload: { token, user } }) {
      state.token = token;
      state.user  = user;
      sessionStorage.setItem(TOKEN_KEY, token);
      localStorage.setItem(USER_KEY, JSON.stringify(user));
    },
    setProject(state, { payload: project }) {
      state.project = project;
      localStorage.setItem(PROJECT_KEY, JSON.stringify(project));
    },
    clearSession(state) {
      state.token   = null;
      state.user    = null;
      state.project = null;
      sessionStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      localStorage.removeItem(PROJECT_KEY);
    },
  },
});

export const { setCredentials, setProject, clearSession } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectToken   = state => state.auth.token;
export const selectUser    = state => state.auth.user;
export const selectProject = state => state.auth.project;
